import { type Query } from '@tanstack/react-query'
import { createQueryClient } from '@zealth/core/query'

import { Sentry } from '@/config/sentry'

export const queryClient = createQueryClient({
  captureException: Sentry.captureException,
})

// Queries whose key starts with `'global'` are not user-scoped (dictionary,
// shared survey bundles, etc.) and survive auth swaps unchanged. This
// predicate lets `resetQueries` / `invalidateQueries` target only the
// user-scoped slice, sparing the dictionary refetch on every impersonation
// switch.
export const isUserScopedQuery = (query: Query): boolean =>
  query.queryKey[0] !== 'global'
